import Cookies from 'js-cookie';
import { SARS_HIGH_INTENT_COOKIE, UNASSIGNED } from '../constants';

// The cookie is written upstream, so 'unassigned' means "no value on this load", not "not high intent"
export const getHighIntentCookie = () => {
  const value = Cookies.get(SARS_HIGH_INTENT_COOKIE);
  let parsed: Record<string, any> = {};

  if (value) {
    try {
      parsed = JSON.parse(value);
    } catch {
      parsed = {};
    }
  }

  return {
    highIntentCookie: value || UNASSIGNED,
    hasHighIntentCookie: Boolean(value),
    parsed,
  };
};
